import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const ToggleSvg = /* @__PURE__ */ __name(() => /* @__PURE__ */ React.createElement("svg", {
  "aria-hidden": "true",
  className: "mds-switch-icon-toggle",
  fill: "none",
  focusable: "false",
  viewBox: "0 0 40 20"
}, /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-switch-svg-fill)",
  height: "20",
  rx: "10",
  width: "40"
}), /* @__PURE__ */ React.createElement("circle", {
  cy: "10",
  fill: "var(--toggle-icon)",
  r: "7"
})), "ToggleSvg");

export { ToggleSvg };
//# sourceMappingURL=toggle-svg.js.map
